import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Lectura del Futuro** de 10 cartas sobre lo que se avecina para ${
        data.consultante.name
    }${data.consultante.zodiac ? ` de signo ${data.consultante.zodiac}` : ''}${
        data.consulta.length > 0 ? `, que realiza la siguiente consulta: ${data.consulta}` : ''
    }.

IMPORTANTE:
- Esta tirada NO es un retrato psicológico del presente ni un resumen de lo que la persona ya está viviendo.
- El foco principal es el **movimiento hacia adelante**: qué se activa, qué cambia, qué aparece y hacia dónde se inclina la situación.
- Sé concreto y directo. Evitá repetir la misma idea en varias posiciones.
- Hablá de tendencias claras, no de certezas absolutas.
- Si una carta refuerza el presente, usala solo como punto de partida y avanzá rápido hacia lo que viene.

Las 10 posiciones:
1. **Momento actual** (${cardLabel(cards[0])}): breve punto de partida. Máximo 2-3 líneas. No te extiendas acá.
2. **Lo que viene en el corto plazo** (${cardLabel(cards[1])}): qué se empieza a mover en las próximas semanas / 1-2 meses. Buscá activación o cambio.
3. **El tema principal que se activa** (${cardLabel(cards[2])}): el asunto central que toma protagonismo de ahora en más.
4. **Desarrollo en el amor / vínculos** (${cardLabel(cards[3])}): tendencia concreta en lo afectivo. ¿Se abre, se cierra, se complica, aparece algo nuevo?
5. **Desarrollo en lo laboral / dinero** (${cardLabel(cards[4])}): tendencia concreta en trabajo y recursos. ¿Avance, estancamiento, presión, oportunidad?
6. **Obstáculo o complicación** (${cardLabel(cards[5])}): qué puede trabar, demorar o generar fricción en el camino.
7. **Algo inesperado** (${cardLabel(cards[6])}): elemento, persona o situación que no está en el radar actual.
8. **Cómo se resuelve / gira** (${cardLabel(cards[7])}): hacia dónde se inclina la energía. ¿Se desbloquea, se tensa, se reorienta?
9. **Tiempo relativo** (${cardLabel(cards[8])}): ritmo general (rápido, medio, lento) y qué implica eso.
10. **Resultado más probable** (${cardLabel(cards[9])}): la tendencia de cierre más fuerte. Sé claro y directo.

Instrucciones de estilo:
- Hacé un relato fluido nombrando las cartas dentro de la interpretación (sin enumerar “carta 1, carta 2…”).
- Dirígete al consultante en segunda persona.
- Evitá repetir el mismo diagnóstico emocional en varias posiciones.
- Buscá contraste entre áreas (por ejemplo entre lo afectivo y lo laboral).
- Priorizá información nueva y de futuro por sobre la descripción del estado actual.

Al final incluí:
- Un párrafo de **Respuesta directa** a la inquietud del consultante (si la hay).
- Un **Consejo final** concreto y accionable (máximo 3-4 líneas).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
